import type { valute } from '../general/types'
import valuteData from '../../data/valute.json'

export class valuteService {
  async getValuteList(typeValute: Number[] | null): Promise<{ data: valute[] }> {

    if (!typeValute)
      return { data: valuteData.data.filter((item) => [1, 2, 3].includes(item.id)) }

    return  {data: valuteData.data.filter((item) => typeValute.includes(item.id)) }
  }
}
